import ToolKitImg1 from "../../assets/images/toolkitIcon1.svg";
import ToolKitImg2 from "../../assets/images/toolkitIcon2.svg";
import ToolKitImg3 from "../../assets/images/toolkitIcon3.svg";

import MediaKitImg1 from "../../assets/images/mediaKitImg1.svg";
import MediaKitImg2 from "../../assets/images/mediaKitImg2.svg";
import MediaKitImg3 from "../../assets/images/mediaKitImg3.svg";
import MediaKitImg4 from "../../assets/images/mediaKitImg4.svg";

export const toolkitData = [
  {
    id: 1,
    img: ToolKitImg1,
    alt: "Research Methodology Toolkit",
    title: "Research Methodology Toolkit",
    description:
      "Comprehensive guide covering quantitative and qualitative research methods",
    tags: ["142 pages", "Free Download"],
    download: "3,240 downloads",
    rating: "4.8/5 rating",
    buttonText: "Download Toolkit",
  },
  {
    id: 2,
    img: ToolKitImg2,
    alt: "Impact Assessment Report",
    title: "Impact Assessment Report",
    description:
      "Annual report showcasing IMPARC's research impact and outcomes",
    tags: ["86 pages", "2024 Edition"],
    download: "1,876 downloads",
    time: "Updated Q1 2024",
    buttonText: "Download Toolkit",
  },
  {
    id: 1,
    img: ToolKitImg3,
    alt: "Best Practices Guide",
    title: "Best Practices Guide",
    description:
      "Compilation of proven strategies for successful research collaboration",
    tags: ["67 pages", "Interactive"],
    download: "2,154 downloads",
    rating: "Multi-institutional",
    buttonText: "Download Toolkit",
  },
];

export const BooksData = [
  {
    id: 1,
    title: "Special Issue: AI in Healthcare",
    description:
      "We invite submissions exploring the applications, challenges, and ethical considerations of artificial intelligence in healthcare systems.",
    tag: "Open Call",
    pages: "Full papers: 6,000-8,000 words",
    scope: "International scope",
    awards: "Indexed in Scopus & Web of Science",
  },
  {
    id: 2,
    title: "Sustainable Innovation Handbook",
    description:
      "Call for chapters on sustainable technologies, green innovation, and environmental research methodologies.",
    tag: "Book Chapter",
    pages: "Chapters: 4,000-6,000 words",
    scope: "ISBN publication",
    awards: "Expert editorial board",
  },
];

export const announcementNewsData = [
  {
    id: 1,
    title: "Strategic Alliance with Global Research Council",
    description:
      "IMPARC announces new partnership to expand international research collaboration opportunities.",
    tag: "New Partnership",
  },
  {
    id: 2,
    title: "Excellence in Research Impact Award",
    description:
      "IMPARC receives prestigious recognition for outstanding contribution to global research advancement.",
    tag: "Award",
  },
  {
    id: 3,
    title: "Annual Conference 2024 Registration Open",
    description:
      "Early bird registration now available for IMPARC's flagship annual research conference.",
    tag: "Event",
  },
];

export const mediakitData = [
  {
    id: 1,
    img: MediaKitImg1,
    alt: "Logo Package",
    title: "Logo Package",
    description: "High-res logos in various formats",
    tags: ["PNG, SVG, EPS"],
  },
  {
    id: 2,
    img: MediaKitImg2,
    alt: "Brochures",
    title: "Brochures",
    description: "Institutional & program brochures",
    tags: ["PDF, 8.5MB"],
  },
  {
    id: 3,
    img: MediaKitImg3,
    alt: "Presentations",
    title: "Presentations",
    description: "PowerPoint templates & slides",
    tags: ["PPTX, 12MB"],
  },
  {
    id: 4,
    img: MediaKitImg4,
    alt: "Brand Guidelines",
    title: "Brand Guidelines",
    description: "Colors, fonts & usage guidelines",
    tags: ["PDF, 3.2MB"],
  },
];
